import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
  marginRight?: number;
}

const Grading: React.FC<Props> = ({
  color = 'inherit',
  fontSize = 'inherit',
  marginRight = 'inherit',
}) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{
        fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`,
        color,
        marginRight,
      }}
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect
        id="Rectangle_1389"
        data-name="Rectangle 1389"
        width="20"
        height="20"
        fill="#176bfb"
        opacity="0"
      />
      <g id="Icon_feather-percent" data-name="Icon feather-percent" transform="translate(-3 -3)">
        <path
          id="Path_5998"
          data-name="Path 5998"
          d="M7.5,20.873a.75.75,0,0,1-.53-1.28L19.592,6.97A.75.75,0,0,1,20.653,8.03L8.03,20.653A.748.748,0,0,1,7.5,20.873Z"
          transform="translate(-0.598 -0.598)"
          fill="#213960"
        />
        <path
          id="Path_5999"
          data-name="Path 5999"
          d="M8.254,5.25a3,3,0,1,1-3,3A3.007,3.007,0,0,1,8.254,5.25Zm0,4.508a1.5,1.5,0,1,0-1.5-1.5A1.506,1.506,0,0,0,8.254,9.758Z"
          transform="translate(0 0)"
          fill="#213960"
        />
        <path
          id="Path_6000"
          data-name="Path 6000"
          d="M24.754,21.75a3,3,0,1,1-3,3A3.007,3.007,0,0,1,24.754,21.75Zm0,4.508a1.5,1.5,0,1,0-1.5-1.5A1.506,1.506,0,0,0,24.754,26.258Z"
          transform="translate(-6.582 -6.582)"
          fill="#213960"
        />
      </g>
    </svg>
  );
};

export default Grading;
